import script from "./HouseRent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HouseRent.vue?vue&type=script&lang=ts&setup=true"

import "./HouseRent.vue?vue&type=style&index=0&id=5f050724&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f050724"]])

export default __exports__